/**
 * Next.js client instrumentation (auto-loaded — runs in the browser).
 *
 * Initializes Sentry in the browser ONLY when `NEXT_PUBLIC_SENTRY_DSN` is set.
 * With no public DSN this file does nothing, so the wrapper in
 * lib/observability/sentry.ts is a no-op on the client too.
 *
 * Conservative defaults: low trace sampling, NO session replay. See
 * docs/MONITORING.md.
 */
import * as Sentry from '@sentry/nextjs';

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    // No session replay by default (privacy + bundle weight).
  });
}

// Instrument client-side router navigations (no-op if Sentry wasn't init'd).
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
